import axios from "axios";
import { handleError } from "@/services/errorUtility";

function getDefaultState() {
    return {
        settings: {
            prices: {
                fullAccess: 0,
                school: 0
            }
        },
        isLoaded: false
    }
}

const state = getDefaultState;

const getters = {
    settings: state => state.settings,

    fullAccessPriceFormatted: state => {
        const price = state.settings?.prices?.fullAccess ?? 0;
        if (price <= 0) {
            return "-";
        }
        return Number(price).toFixed(2);
    },

    schoolPriceFormatted: state => {
        const price = state.settings?.prices?.school ?? 0;
        if (price <= 0) {
            return "-";
        }
        return Number(price).toFixed(2);
    }
}

const actions = {
    async load({ commit, state }) {
        if (state.isLoaded) {
            return;
        }

        try {
            const settings = (
                await axios.get("/api/StripeSubscriptions/Settings", { timeout: 10000 })
            ).data;
            commit("settings", settings);
        } catch (error) {
            handleError(error);
            commit("loaded");
        }
    },
    clear({ commit }) {
        commit("clear");
    }
};

const mutations = {
    settings(state, settings) {
        state.settings = settings;
        state.isLoaded = true;
    },
    loaded(state) {
        state.isLoaded = true;
    },
    clear(state) {
        Object.assign(state, getDefaultState());
    }
}

export const stripe = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
